<template>
  <div class="grid-view">
    <div class="main-content">
      <div class="form-column">
        <span class="title">{{ $t('CargoMsg.Cargo_LoginEnterpriseWechat') }}</span>
        <img v-show="!loginSuccess" :src="selectedRow.qrcodeUrl" style="width: 240px;height: 300px;cursor: pointer">
        <div v-show="loginSuccess" style="width:240px;height:300px;margin-bottom:-17px;padding-top:120px;border:1px solid #c3c3c3;cursor:pointer">
          <span style="margin-left:30px;">{{ loginSuccessTip }}</span>
        </div>
        <span style="color:#1890ff;margin-left:10px;">{{ captchaUsingTip }}</span>
        <br>
        <span>{{ $t('CargoMsg.Cargo_LoginEnterpriseWechatTip') }}</span>
        <br>
        <div style="padding-top: 6px; width: 100%; border-bottom: 1px solid black;" />
        <span class="title" style="padding-top: 10px">{{ $t('CargoMsg.Cargo_RpaAccountSummary') }}</span>
        <div class="grid-wrapper" style="width: 1000px; min-height: 210px; padding-bottom: 0;margin-top:-10px;">
          <span>{{ $t('CargoMsg.Cargo_RpaAccountSummaryTip') }}</span>
          <cargo-left-right-resize
            style="width: 100%;"
            :show-right="dgCompany.show"
            :left-style="{'min-width': '30%'}"
            :right-style="{'min-width': '70%'}"
          >
            <div slot="left">
              <div class="app-main-inner-row row-grid-dialog" style="min-height:210px; padding: 0;">
                <cargo-ag-grid
                  :grid-options="dgGroup.gridOptions"
                  :column-defs="dgGroup.columnDefs"
                  :row-data="rpaAccounts"
                  style="width:100%;min-height: 300px"
                  @gridReady="onGridReady_dgGroup"
                />
              </div>
            </div>
            <div
              slot="right"
              class="app-main-inner-row row-grid-dialog"
              style="height: 100%; min-height: 300px; padding: 0;"
            >
              <cargo-ag-grid
                :grid-options="dgCompany.gridOptions"
                :column-defs="dgCompany.columnDefs"
                :row-data="dgCompanyRowData"
                style="width:100%;"
                @gridReady="onGridReady_dgCompany"
              />
            </div>
          </cargo-left-right-resize>
        </div>
      </div>
    </div>
    <!--输入验证码-->
    <el-dialog
      v-el-drag-dialog
      custom-class=""
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
      :visible.sync="verificationCodeDialog.visible"
      :title="$t('CargoMsg.Cargo_PleaseInputVerificationCode')"
      width="335px"
      class="verification-code-dialog"
    >
      <el-form label-width="0" label-position="left" style="font-size:14px;margin-left:12px;margin-right: 16px" @submit.native.prevent>
        <el-form-item>
          <span>{{ verificationCodeTip }}</span>
        </el-form-item>
        <el-form-item>
          <el-input v-model="verificationCodeDialog.verificationCode" no="verificationCode" />
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button size="mini" @click="verificationCodeDialog.visible=false">{{ $t('CargoMsg.Cargo_Cancel') }}</el-button>
        <el-button size="mini" type="primary" @click="saveVerificationCodeHandler">{{ $t('CargoMsg.Cargo_ConfirmR') }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import ColumnUtils from '@/utils/ColumnUtils'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import cargoLeftRightResize from '@/components/Cargo/Common/cargoLeftRightResize'
import CustomLableUtils from '@/utils/CustomLabelUtils'
import { sortByMultiFieldAndOrder } from '@/utils'
import { getLoading } from '@/utils/utilBaseElement'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import { saveVerificationCode, queryRpaAccounts } from '@/api/partner/contact'

export default {
  name: 'TabEnterpriseWechat',
  components: { cargoLeftRightResize },
  props: {
    activeTabName: { type: String, default: () => '' },
    office: { type: Object, required: true } // 分公司
  },
  data() {
    return {
      selectedRow: {}, // 当前选中行
      dgGroup: {
        gridOptions: {
          onRowClicked: this.onRowClicked1,
          defaultColDef: {
            filter: false
          }
        },
        gridParams: {},
        gridApi: {},
        columnDefs: [
          { headerName: this.$t('CargoMsg.Cargo_RpaAccountColumn'), field: 'wechatAccount', initialWidth: 120, minWidth: 120, sortable: false, enableRowGroup: true },
          { headerName: this.$t('CargoMsg.Cargo_RpaAccountEnabled'), field: 'enabled', initialWidth: 100, minWidth: 100, sortable: false, enableRowGroup: true,
            valueFormatter: (params) => {
              return ColumnUtils.rpaAccountEnabledLabelFunc(params.value)
            }
          }
        ],
        rowData: []
      },
      dgCompany: {
        show: true,
        gridParams: {},
        gridOptions: {
          rowSelection: 'multiple',
          suppressCopyRowsToClipboard: true,
          suppressRowSelection: true,
          suppressCellSelection: true,
          suppressRowClickSelection: true,
          context: {
            componentParent: this
          },
          defaultColDef: {
            resizable: true,
            filter: false
          },
          pagination: false
        },
        gridApi: {},
        columnDefs: [
          { headerName: this.$t('CargoMsg.Cargo_SequenceNumber'), field: 'serialNumber', initialWidth: 50, minWidth: 50, sortable: false, enableRowGroup: true },
          { headerName: this.$t('CargoMsg.Cargo_AssociatePartners'), field: 'cmpIdx', initialWidth: 200, minWidth: 200, sortable: false, enableRowGroup: true,
            valueFormatter: (params) => {
              return params.value ? CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', Number(params.value), 'auto_0') : ''
            }
          },
          { headerName: this.$t('CargoMsg.Cargo_Contact'), field: 'contactPerson', initialWidth: 120, minWidth: 120, sortable: false, enableRowGroup: true },
          { headerName: this.$t('CargoMsg.Cargo_WechatGroupName'), field: 'wechatGroupName', initialWidth: 200, minWidth: 200, sortable: false, enableRowGroup: true }
        ],
        rowData: []
      },
      timer: null,
      verificationCodeDialog: {
        visible: false,
        wechatAccount: '',
        verificationCode: ''
      }
    }
  },
  computed: {
    rpaAccounts() {
      const rpaAccountList = this.office.rpaAccounts || []
      sortByMultiFieldAndOrder(rpaAccountList, { serialNo: 'asc' })
      return rpaAccountList
    },
    rpaAccountContacts() {
      return this.office.rpaAccountContacts || []
    },
    dgCompanyRowData() {
      const wechatAccount = this.selectedRow.wechatAccount || ''
      const rpaAccountList = this.rpaAccountContacts.filter(function(elem) {
        return (elem.rpaAccount === wechatAccount)
      })
      sortByMultiFieldAndOrder(rpaAccountList, { companyName: 'asc' })
      rpaAccountList.forEach((item, index) => { item.serialNumber = index + 1 })
      return rpaAccountList
    },
    verificationCodeTip() {
      if (this.verificationCodeDialog.visible && this.selectedRow && this.selectedRow.rpaLoginType === SystemConstants.RPALOGIN_TYPE_CAPTCHA.code) {
        if (!this.selectedRow.loginDate && this.selectedRow.rpaReturnError !== 'Invalid captcha') {
          return this.$t('CargoMsg.Cargo_InputVerificationCodeTip1')
        } else {
          return this.$t('CargoMsg.Cargo_InputVerificationCodeTip2')
        }
      }
      return ''
    },
    captchaUsingTip() {
      if (this.selectedRow && this.selectedRow.rpaLoginType === SystemConstants.RPALOGIN_TYPE_CAPTCHA_USING.code) {
        return this.$t('CargoMsg.Cargo_CaptchaUsing')
      }
      return ''
    },
    loginSuccess() {
      if (this.selectedRow && this.selectedRow.rpaLoginType === SystemConstants.RPALOGIN_TYPE_LOGIN_SUCCESS.code) {
        return true
      }
      return false
    },
    loginSuccessTip() {
      if (this.selectedRow && this.selectedRow.rpaLoginType === SystemConstants.RPALOGIN_TYPE_LOGIN_SUCCESS.code) {
        return this.$t('CargoMsg.Cargo_LoginSuccess', [this.selectedRow.wechatAccount])
      }
      return ''
    }
  },
  watch: {
    office(val) {
      if (val) {
        this.$nextTick(() => {
          if (this.rpaAccounts.length !== 0) {
            this.selectedRow = this.rpaAccounts[0]
          } else {
            this.selectedRow = {}
          }
        })
      }
    },
    activeTabName(val, oldVal) {
      if (val && val !== oldVal && val === 'enterpriseWechat' && !this.timer) {
        this.fetchData(false)
      } else {
        this.cleanTimer()
      }
    }
  },
  beforeDestroy() {
    this.cleanTimer()
  },
  methods: {
    onGridReady_dgGroup(params) {
      this.dgGroup.gridApi = params.api
    },
    onGridReady_dgCompany(params) {
      this.dgCompany.gridApi = params.api
    },
    onRowClicked1(event) {
      this.selectedRow = event.data
      this.showVerificationCodeDialog()
    },
    showVerificationCodeDialog() {
      if (this.selectedRow && this.selectedRow.rpaLoginType === SystemConstants.RPALOGIN_TYPE_CAPTCHA.code && (!this.selectedRow.verificationCode || this.selectedRow.rpaReturnError === 'Invalid captcha')) {
        this.verificationCodeDialog.visible = true
        this.verificationCodeDialog.wechatAccount = this.selectedRow.wechatAccount
        this.verificationCodeDialog.verificationCode = ''
      }
    },
    saveVerificationCodeHandler() {
      if (!this.verificationCodeDialog.verificationCode) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseInputVerificationCode'))
        return
      }
      const obj = {}
      obj.wechat_account = this.verificationCodeDialog.wechatAccount
      obj.captcha = this.verificationCodeDialog.verificationCode
      this.loading = getLoading()
      saveVerificationCode(obj).then(res => {
        this.verificationCodeDialog.visible = false
        if (res.data) {
          this.$message.success(this.$t('CargoMsg.Cargo_CaptchaUsing'))
          // 刷新
          this.selectedRow = res.data
          for (const item of this.rpaAccounts) {
            if (this.selectedRow.wechatAccount === item.wechatAccount) {
              item.rpaLoginType = this.selectedRow.rpaLoginType
              item.verificationCode = this.selectedRow.verificationCode
              item.verificationDate = this.selectedRow.verificationDate
              item.qrcodeUrl = this.selectedRow.qrcodeUrl
              item.qrcodeDate = this.selectedRow.qrcodeDate
              item.loginDate = this.selectedRow.loginDate
              item.rpaReturnError = this.selectedRow.rpaReturnError
              item.enabled = this.selectedRow.enabled
            }
          }
          this.dgGroup.gridApi.refreshCells({ force: true })
        }
      }).finally(() => {
        this.loading.close()
      })
    },
    fetchData(silent = true) {
      console.log('queryRpaAccounts')
      if (!silent) {
        this.loading = getLoading()
      }
      if (this.timer) {
        this.cleanTimer()
      }
      queryRpaAccounts({ officeId: this.office.officeId }).then(res => {
        if (silent) {
          if (res.data && res.data.length > 0 && this.rpaAccounts && this.rpaAccounts.length > 0) {
            const dataMap = new Map()
            res.data.forEach(item => {
              dataMap[item.uuid] = item
            })
            // 刷新
            for (let i = 0; i < this.rpaAccounts.length; ++i) {
              const item = this.rpaAccounts[i]
              const dataItem = dataMap[item.uuid]
              if (!dataItem) {
                continue
              }
              item.rpaLoginType = dataItem.rpaLoginType
              item.verificationCode = dataItem.verificationCode
              item.verificationDate = dataItem.verificationDate
              item.qrcodeUrl = dataItem.qrcodeUrl
              item.qrcodeDate = dataItem.qrcodeDate
              item.loginDate = dataItem.loginDate
              item.rpaReturnError = dataItem.rpaReturnError
              item.enabled = dataItem.enabled
              //
              if (this.selectedRow.wechatAccount === item.wechatAccount) {
                this.selectedRow = item
              }
            }
            this.dgGroup.gridApi.refreshCells({ force: true })
          }
        }
      }).finally(() => {
        if (!silent) {
          !this.loading || this.loading.close()
        }
        this.setTimer()
      })
    },
    setTimer() {
      console.log('setTimer')
      this.timer = setTimeout(() => {
        this.fetchData()
      }, 10000)
    },
    cleanTimer() {
      clearTimeout(this.timer)
      this.timer = null
    }
  }
}
</script>

<style lang="scss" scoped>
.form-column{
  background-color: #f0f3f8;
  padding: 10px 20px 20px;
  margin: 0;
  .el-form{
    padding-left: 20px;
    .el-select{
      width: 300px !important;
    }
  }
  > p{
    margin: 5px 20px 0 0;
    text-align: right;
    color: #409eff;
    cursor: pointer;
    user-select: none;
    display: block;
  }
  .title{
    line-height: 22px;
    font-size: 14px;
    padding-bottom: 8px;
    font-weight: bold;
    display: block;
    i{
      margin-left: 5px;
      font-size: 14px;
    }
  }
}
.grid-wrapper{
  margin-top: 5px;
  background-color: #f0f3f8;
  padding: 5px;
  flex-direction: column;
  .screen-btn{
    display: block;
    margin: 5px 0 10px 30px;
    .el-button{
      margin-right: 10px;
    }
  }
}
.title{
  line-height: 22px;
  font-size: 14px;
  padding-bottom: 8px;
  font-weight: bold;
  display: block;
  i{
    margin-left: 5px;
    font-size: 14px;
  }
}
.verification-code-dialog ::v-deep {
  .el-dialog__header {
    border: none;
  }
  .el-dialog__body {
    font-size: 14px !important;
    padding: 0 !important;
  }
  .el-dialog__footer {
    margin-top: 20px;
    border: none;
  }
}
</style>
